const getCamelizeValue = (value: string) => {
  return value.replace(/-./g, (x) => x[1].toUpperCase());
};

export default getCamelizeValue
